import React from 'react';
import SubNavigation from './SubNavigation';
import Collapsible from '../Collapsible';
import { translate } from '../../Services/translation';
import { SubNavigationLinkModel } from '../../Types/SubNavigationLinkModel';

const SubNavigationContainer = ({
  links,
  name,
  url,
}: SubNavigationLinkModel) => {
  return (
    <>
      <div className="md:hidden">
        <Collapsible
          className="[&_>label]:bold mb-6 rounded border border-gray-300 !pb-0 [&_.ReactCollapsible--content]:!pb-0 [&_>label]:!pl-4 [&_>label]:!pr-4"
          label={translate('subnavigation.mobile-title')}
        >
          <SubNavigation links={links} name={name} url={url} />
        </Collapsible>
      </div>
      <div className="hidden md:block">
        <SubNavigation links={links} name={name} url={url} />
      </div>
    </>
  );
};

export default SubNavigationContainer;
